export function isPwaMode(): boolean {
	return window.matchMedia('(display-mode: standalone)').matches;
}
